export default "__VITE_ASSET__Bhp9XNS4__"